module.exports = __webpack_public_path__ + "img/driver.28461518.svg";